import { DirectionDTO } from '../../../openapi/shell-service-openapi';
import { AdminAnnouncementState } from './admin-announcement.state';

/**
 * Initialer State für das Admin-Announcement Dashboard.
 *
 * sortProperties/sortDirections sind bewusst nicht leer initialisiert:
 * Der Default muss mit dem Backend-Default (activeFrom DESC) und
 * DEFAULT_TABLE_SETTINGS (_sortParams: ['createdAt'], _sortDirs: ['desc'])
 * synchron sein, damit UI und API-Response konsistent starten.
 */
export const adminAnnouncementStateInitial: AdminAnnouncementState = {
  pageIndex: 0,
  pageSize: 50,
  sortProperties: ['createdAt'],
  sortDirections: [DirectionDTO.Desc],
  displayedIds: [],
  editorMode: null,
  editingAnnouncementId: null,
  isSaving: false,
  saveError: null,
};
